var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / IQ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-IQ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#DF1E35",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6666667,8.34103775 C18.6666667,8.1526878 18.7993863,8.06635984 18.9625765,8.14795494 L19.7040901,8.51871173 C19.8675166,8.60042498 20,8.80989583 20,8.99846586 L20,11.6682008 C20,11.8514484 19.85731,12 19.6635437,12 L19.003123,12 C18.8173033,12 18.6666667,11.8480797 18.6666667,11.6589622 L18.6666667,8.34103775 Z",
    id: "Rectangle-213",
    fill: "#0F7A40",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,8.34103775 C10.6666667,8.1526878 10.7993863,8.06635984 10.9625765,8.14795494 L11.7040901,8.51871173 C11.8675166,8.60042498 12,8.80989583 12,8.99846586 L12,11.6682008 C12,11.8514484 11.85731,12 11.6635437,12 L11.003123,12 C10.8173033,12 10.6666667,11.8480797 10.6666667,11.6589622 L10.6666667,8.34103775 Z",
    id: "Rectangle-213",
    fill: "#0F7A40",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8.99846586 C16,8.81521822 16.1327197,8.60030683 16.2959099,8.51871173 L17.0374235,8.14795494 C17.20085,8.06624168 17.3333333,8.15192032 17.3333333,8.34103775 L17.3333333,11.6589622 C17.3333333,11.8473122 17.1906433,12 16.996877,12 L16.3364563,12 C16.1506366,12 16,11.8567708 16,11.6682008 L16,8.99846586 Z",
    id: "Rectangle-213",
    fill: "#0F7A40",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,10.3302593 C13.3333333,10.1478621 13.466053,9.93364016 13.6292432,9.85204506 L14.3707568,9.48128827 C14.5341833,9.39957502 14.6666667,9.48241364 14.6666667,9.67055088 L14.6666667,10.7263792 L16.6666667,10.7263792 L16.6666667,12 L14.996926,12 C14.8145288,12 14.5239766,12 14.3302104,12 L13.6697896,12 C13.4839699,12 13.3333333,11.8430634 13.3333333,11.6697407 L13.3333333,10.3302593 Z",
    id: "Rectangle-213",
    fill: "#0F7A40",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.3302593 C8,10.1478621 8.13271968,9.93364016 8.29590988,9.85204506 L9.03742345,9.48128827 C9.20084997,9.39957502 9.33333333,9.48241364 9.33333333,9.67055088 L9.33333333,10.7263792 L11.3333333,10.7263792 L11.3333333,12 L9.66359266,12 C9.48119547,12 9.19064331,12 8.99687703,12 L8.3364563,12 C8.15063662,12 8,11.8430634 8,11.6697407 L8,10.3302593 Z",
    id: "Rectangle-213",
    fill: "#0F7A40",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/IQ.6966da24e9c7203bc7925405eaa152e5.svg";
export { ForwardRef as ReactComponent };